import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../../api/services/firebaseAnalyticsService';
import { useCookieConsent } from '../../context/CookieConsentContext';

const AnalyticsRouteTracker = () => {
  const location = useLocation();
  const { analyticsAllowed } = useCookieConsent();

  useEffect(() => {
    if (!analyticsAllowed) return;
    const path = `${location.pathname}${location.search}${location.hash}`;
    trackPageView(path);
  }, [location, analyticsAllowed]);

  return null;
};

export default AnalyticsRouteTracker;
